import axios from "axios";
import React, { useEffect, useState } from "react";
import { base_url } from "../../utils/AxiosConfig";

import { LuPanelLeftOpen, LuPanelRightOpen } from "react-icons/lu";

import SnackbarNotification from "../../utils/SnackbarNotification";
import dayjs from "dayjs";
import { FallingLines } from "react-loader-spinner";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useNavigate } from "react-router-dom";
import { base_url_image_view_api } from "../../utils/ImageViewingAPI";
// import user1 from "../../../images/ic_no_person_photo.svg";
import user1 from "../../images/ic_no_person_photo.svg";

const DailyAttendanceReport = () => {
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [selectedEmpID, setSelectedEmpID] = useState("");
  const [records, setRecords] = useState([]);
  const [payrollData, setPayrollData] = useState([]);
  const [paySlipData, setPaySlipData] = useState(null);
  const [Open, setOpen] = useState(false);
  const [showPayslip, setShowPayslip] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [payslipStartDate, setPayslipStartDate] = useState(
    dayjs().startOf("month").format("YYYY-MM-DD"),
    // dayjs().startOf("month").format("DD-MMM-YYYY"),
  );
  const [payslipEndDate, setPayslipEndDate] = useState(
    dayjs().format("YYYY-MM-DD"),
    // dayjs().format("DD-MMM-YYYY"),
  );
  const [branchListFromAPI, setBranchListFromAPI] = useState([]);
  const [branch, setBranch] = useState("-");
  const [deptListFromAPI, setDeptListFromAPI] = useState([]);
  const [dept, setDept] = useState("-");
  const [gradeListFromAPI, setGradeListFromAPI] = useState([]);
  const [grade, setGrade] = useState("-");

  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "success",
    message: "",
  });

  useEffect(() => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }
    // fetchPayrollData(companyCode);
    getBranchList(companyCode);
    getDeptList(companyCode);
    // getGradeList(companyCode);
    getData();
  }, []);

  const getBranchList = async () => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }

    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/DEPARTMENT/-`,
      // `${base_url}/api/MASTERLIST/CUBIX/DEPARTMENT/-`
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setBranchListFromAPI(newArray.map((i) => i.Description));
    } else {
      console.log("error");
    }
  };

  const getDeptList = async () => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }

    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/DEPT/-`,
      // `${base_url}/api/MASTERLIST/CUBIX/DEPT/-`
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      console.log("dept newArray", newArray);
      setDeptListFromAPI(newArray.map((i) => i.Description));
    } else {
      console.log("error");
    }
  };

  const getGradeList = async (companyCode) => {
    const response = await axios.get(
      // `${base_url}/api/MASTERLIST/CUBIX/GRADE/-`
      `${base_url}/api/MASTERLIST/${companyCode}/GRADE/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      // console.log('newArrayList',newArray.map((i)=>i.Description))
      // console.log('newArray',newArray)
      setGradeListFromAPI(newArray.map((i) => i.Description));
      // setGrade(newArray);
    } else {
      console.log("error");
    }
  };

  const [loader, setLoader] = useState(true);

  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }

  const showSnackbar = (severity, message) => {
    setSnackbar({ open: true, severity, message });
  };

  const handleClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const callPaySlipAPI = async (empID) => {
    console.log("payslip empId", empID);
    setIsLoading(true);
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }

    try {
      const response = await axios.get(
        `${base_url}/api/Payslip/${companyCode}/${payslipStartDate}/${payslipEndDate}/${empID}`,
        // `${base_url}/api/Payslip/CUBIX/${payslipStartDate}/${payslipEndDate}/${empID}`
      );

      if (response.status === 200) {
        showSnackbar("success", "Payslip generated successfully");
        setShowPayslip(true);
      } else {
        showSnackbar("error", "Failed to generate payslip.");
      }
    } catch (error) {
      showSnackbar("error", "An error occurred while payslip.");
    } finally {
      setIsLoading(false);
    }
  };

  const resetPayrollFilters = () => {
    setBranch("-");
    setDept("-");
    setGrade("-");
  };

  const getData = async () => {
    setLoader(true);
    try {
      const response = await axios.get(
        // `${base_url}/api/PersonalInfoList/${companyCode}/${searchType}/${empStatus}/${searchParam}/${jobTitleParam}/${gradeParam}/${divisionParam}`,
        `https://cubixweberp.com:213/api/PersonalInfoList/cubix/ALL/undefined/ALL/ALL/ALL/ALL`,
      );
      const data = response.data;
      console.log("Data Employee List:", data);
      setRecords(data);
    } catch (error) {
      console.error("Error fetching data:", error);
      // toast.error("Error fetching employee data");
    } finally {
      setLoader(false);
      // if (resetalldata) setResetallData(false);
    }
  };

  const fetchProfilePic = (ImagePath) => {
    if (!ImagePath) return user1;
    const filePath = ImagePath.replace(/\\/g, "/");
    const fileName = filePath.split("/").pop();
    return `${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`;
  };

  console.log("Selected Employee:", selectedEmp);

  return (
    <div>
      <div className="flex justify-between items-end mb-4 ">
        {/* <h6 className="text-2xl mb-2 font-bold text-gray-600 flex  justify-start items-center">
          Payroll
        </h6> */}

        <div className="flex justify-left items-center">
          <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full  mr-2"></div>
          <h6 className="text-xl font-bold text-gray-900 flex items-center gap-4">
            {/* <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-[#2663EB] to-blue-700 text-white shadow-lg">
      <MdPersonAddAlt className="w-7 h-7" />
      </span> */}
            <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
              DAILY ATTENDANCE REPORT
            </span>
          </h6>
        </div>

        <div className="flex justify-center items-end gap-4 ">
          <div className="">
            <label
              htmlFor="exampleInputEmail1"
              className="form-label fs-small text-secondary"
            >
              Emp ID
            </label>
            <input
              className="form-control cursor-not-allowed "
              value={selectedEmp?.EmpId}
              disabled
              // onChange={(e) => setPayslipStartDate(e.target.value)}
              // max={new Date().toISOString().split("T")[0]}
            />
          </div>
          {/* Branch Select */}
          {/* <FormControl variant="outlined" sx={{ minWidth: 180 }} size="small">
            <InputLabel id="branch-select-label">Branch</InputLabel>
            <Select
              labelId="branch-select-label"
              value={branch}
              // onChange={(e) => handleChange(e, "division")}
              label="Branch"
            >
              <MenuItem value="-">
                <em>None</em>
              </MenuItem>
              {branchListFromAPI?.map((b) => (
                <MenuItem
                  key={b.DEPTNO}
                  value={b}
                  onClick={() => {
                    //   setSelectedDivision(b.deptnodesc);
                    setBranch(b);
                  }}
                >
                  {b}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}
          <div className="">
            <label className="block text-sm text-gray-600 ">Branch</label>

            <select
              value={branch || "-"}
              onChange={(e) => setBranch(e.target.value)}
              className="w-full border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="-">None</option>

              {branchListFromAPI?.map((b) => (
                <option key={b.DEPTNO} value={b}>
                  {b}
                </option>
              ))}
            </select>
          </div>

          {/* <FormControl variant="outlined" sx={{ minWidth: 180 }} size="small">
            <InputLabel id="department-select-label">Department</InputLabel>
            <Select
              labelId="department-select-label"
              value={dept}
              // onChange={(e) => handleChange(e, "department")}
              label="Department"
            >
              <MenuItem value="-">
                <em>None</em>
              </MenuItem>
              {deptListFromAPI?.map((dept) => (
                <MenuItem
                  // key={dept.id}
                  value={dept}
                  onClick={() => {
                    setDept(dept);
                    //   setSelectedDepartmentCode(dept.code);
                  }}
                >
                  {dept}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}

          <div className="">
            <label className="block text-sm text-gray-600 mb-1">
              Department
            </label>

            <select
              value={dept || "-"}
              onChange={(e) => setDept(e.target.value)}
              className="w-full border border-gray-300 rounded px-2 py-1 pr-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="-">None</option>

              {deptListFromAPI?.map((d, index) => (
                <option key={index} value={d}>
                  {d}
                </option>
              ))}
            </select>
          </div>

          <button
            onClick={() => resetPayrollFilters()}
            className="btn btn-sm text-sm"
            style={{ backgroundColor: "#1DC7AD", color: "#ffffff" }}
          >
            Reset Filters
          </button>

          <div className="d-flex">
            <div>
              <label
                htmlFor="exampleInputEmail1"
                className="form-label fs-small text-secondary"
              >
                Start Date
              </label>
              <input
                type="date"
                className="form-control"
                id="startDate"
                name="startDate"
                value={payslipStartDate}
                onChange={(e) => setPayslipStartDate(e.target.value)}
                max={new Date().toISOString().split("T")[0]}
              />
            </div>

            <div className="ms-2">
              <label
                htmlFor="exampleInputEmail1"
                className="form-label fs-small text-secondary"
              >
                End Date
              </label>
              <input
                type="date"
                className="form-control"
                id="endDate"
                name="endDate"
                value={payslipEndDate}
                onChange={(e) => setPayslipEndDate(e.target.value)}
                max={new Date().toISOString().split("T")[0]}
              />
            </div>
          </div>

          {/* <div className="flex flex-col justify-center items-center gap-2">
            <button
              // onClick={fetchPayrollData}
              className="bg-violet-500 text-white px-3 py-2 rounded text-xs"
            >
              Timesheet Summary Report
            </button>

            <button
              // onClick={() => printPayrollData()}
              className="bg-yellow-500 text-white px-3 py-2 rounded text-xs"
            >
              Attendance Punch Details
            </button>
          </div> */}
{/* /////////////////////////////////////// */}
          {/* <div className="mb-2">
            {Open === true ? (
              <>
                <LuPanelRightOpen onClick={() => setOpen(false)} />
              </>
            ) : null}
            {Open === false ? (
              <>
                <LuPanelLeftOpen onClick={() => setOpen(true)} />
              </>
            ) : null}
          </div> */}
        </div>
      </div>
      <div className="overflow-auto max-w-85 scrollbar-none rounded-md">
        {payrollData ? (
          <>
            {/* <table className="table-auto w-full bg-white text-xs border-collapse border border-gray-300 shadow-sm rounded-md px-6 overflox-x-auto"> */}
            <table className="shadow-sm min-w-full  rounded-sm border border-[gray-300] text-xs ">
              <thead>
                <tr className="bg-[#2663EB] text-white">
                  <th className="px-1.5 py-1  font-normal">Sl No</th>
                  <th className="px-1.5 py-1   font-normal">Emp ID</th>
                  <th className="px-1.5 py-1   font-normal">Name</th>
                  <th className="px-1.5 py-1   font-normal">Job Title</th>
                  <th className="px-1.5 py-1   font-normal">Department</th>
                  <th className="px-1.5 py-1   font-normal">Division</th>
                  <th className="px-1.5 py-1   font-normal">Time</th>
                  <th className="px-1.5 py-1   font-normal">Type</th>
                </tr>
              </thead>

              <tbody className="text-sm text-gray-700">
                {records?.map((d, i) => {
                  const isSelected = selectedEmp?.EmpId === d?.EmpId;
                  return (
                    <tr
                      onClick={() => setSelectedEmp(d)}
                      key={d.EmpId || i}
                      className={`border transition-colors duration-150 ${isSelected ? "hover:bg-blue-50 bg-blue-100" : "hover:bg-gray-50"} `}
                    >
                      <td className="px-3 py-2 whitespace-nowrap border border-gray-100">
                        {i + 1}
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap border ">
                        {d?.EmpId}
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap border">
                        <div className="flex items-center gap-2">
                          <img
                            className="w-7 h-7 rounded-full object-cover"
                            src={
                              d.imagepath ? fetchProfilePic(d.imagepath) : user1
                            }
                            alt=""
                          />
                          <span>{d?.Name}</span>
                        </div>
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap border">
                        {d?.JobTitle}
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap border">
                        {d?.Department}
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap border">
                        {d?.Division}
                      </td>
                      {/* <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.AlternateID} Time
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.Status} Type
                    </td> */}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </>
        ) : (
          <div className="table-nodata-img">
            <div className="center">
              <p className="text-center pt-5">
                Please Wait Loading Data...
                <FallingLines />
              </p>
            </div>
          </div>
        )}
        <SnackbarNotification
          open={snackbar.open}
          severity={snackbar.severity}
          message={snackbar.message}
          onClose={handleClose}
        />
      </div>
      {showPayslip && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative">
            {/* Close Button */}
            <button
              onClick={() => setShowPayslip(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl"
            >
              &times;
            </button>

            {/* Modal Content */}
            <h2 className="text-lg font-semibold mb-4">Payslip</h2>
            <div className="text-sm space-y-2">
              <p>
                <strong>Name:</strong> {payrollData.name}
              </p>
              <p>
                <strong>Net Pay:</strong> {payrollData.netPay}
              </p>
              <p>
                <strong>Total Wage:</strong> {payrollData.totalWage}
              </p>

              <button onClick={callPaySlipAPI}>Generate Payslip</button>
              {/* Add more payslip fields as needed */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DailyAttendanceReport;
